<template>
  <div id="confirmation">
    <el-alert
      type="success"
      title="Votre paiement a bien été pris en compte"
      :closable="false"
      show-icon
    />

    <h2>Confirmation de votre demande de résiliation</h2>

    <div class="email">
      Vous allez être informé de votre demande de résiliation par email à l'adresse : <span class="conversion-email">{{ email }}</span>
    </div>

    <div class="steps">
      <el-steps direction="vertical" :active="1">
        <el-step
          title="Traitement du dossier et affranchissement"
          description="Dans l'heure (même les dimanches et jours fériés)"
        />
        <el-step
          title="Réception du dossier par le service résiliation."
          description="En moyenne 2 jours ouvrés"
        />
        <el-step title="Dans un délai de 10 jours maximum, votre résiliation est effective." />
      </el-steps>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    email: String
  },
  mounted () {
    if (!sessionStorage.getItem('conversion_tracked')) {
      window.gtag('event', 'conversion', {
        'send_to': 'AW-11163997967/2fCFCJCau5sYEI-utMsp',
        'value': 39.90,
        'currency': 'EUR'
      })
      sessionStorage.setItem('conversion_tracked', '1')
      console.log('+ g_event (confirmation)')
    }
  }
}
</script>

<style lang="scss" scoped>
  h2 {
    font-weight: 600;
  }
  table {
    width: 100%;
  }
  p {
    margin: 25px 0;
  }
  .el-alert {
    margin-top: 25px;
    margin-bottom: 20px;
  }
  .steps {
    height: 170px;
    margin: 25px 0;
  }
</style>

<style lang="scss">
  #confirmation {
    text-align: left;
    max-width: 600px;
    margin: 0 auto;

    .el-alert {
      margin-top: 0;
    }
    .valider {
      margin-top: 25px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/confirmation.vue